<div>
  <table class="operating-hours inputs-table">
    <thead>
    <tr>
      <th scope="col">
        <span class="sentence-case">{{"plan.ct.settings.operating.hours.day.column"|translate}}</span>
      </th>
      <th scope="col">
        <span class="sentence-case">{{"plan.ct.settings.operating.hours.total.column"|translate}}</span>
      </th>
      <td></td>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let day of dayNames">
      <td>
        <span class="day-label sentence-case">{{"plan.ct.settings.operating.hours."+day.toLowerCase() | translate}}</span>
      </td>
      <td>
        <div class="timepicker-container">
          <sol-time-picker [name]="day"
                             [steps]="15"
                             (timeChanged)="onTimeChanged($event, day)"
                             [format]="'hh:mm'"
                             [minTime]="startDate"
                             [maxTime]="endDate"
                             [disableTextInput]="false">
          </sol-time-picker>
        </div>
      </td>
      <td class="day-status">
        <span *ngIf="this.days[day].value==='00:00' && this.days[day].isValid"> {{"plan.ct.settings.operating.hours.closed"|translate}}</span>
        <span *ngIf="this.days[day].value==='--:--' && this.days[day].isValid"> {{"plan.ct.settings.multiple.values"|translate}}</span>
        <span *ngIf="this.days[day].value!=='00:00' && this.days[day].value!=='--:--' && this.days[day].value!=='24:00' && this.days[day].isValid"> {{"plan.ct.settings.operating.hours.partial"|translate}}</span>
        <span *ngIf="this.days[day].value==='24:00' && this.days[day].isValid"> {{"plan.ct.settings.operating.hours.open"|translate}}</span>
        <span *ngIf="this.days[day].isValid === false"> {{"plan.ct.settings.operating.hours.invalid"|translate}}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
